import * as React from 'react'
import { ReactElement } from 'react'
import { useFormikContext } from 'formik'
import { IdentificationType, NaturalPersonMutationDto } from '../../../config/partyMutationConfig'
import FieldRow from './FieldRow'
import FormikInputField from '../../../../components/Formik/FormikInputField'
import FormikComboboxField from '../../../../components/Formik/FormikComboboxField'
import FormikField from '../../../../components/Formik/FormikField'
import EnumCombobox, { EnumComboboxProps } from '../../../../components/Combobox/EnumCombobox'
import LocalDatePicker, { LocalDatePickerProps } from '../../../../components/DatePicker/LocalDatePicker'
import CountryCombobox, { CountryComboboxProps } from '../../../../components/Combobox/i18n/CountryCombobox'

/**
 * Identification document of a natural person. The document types now run through the translation
 * module (AC11) via {@link EnumCombobox} instead of the hardcoded Dutch labels of the old screen.
 */
export default function IdentificationSection(): ReactElement {
    const { values, setFieldValue } = useFormikContext<NaturalPersonMutationDto>()

    return (
        <>
            <FieldRow>
                <FormikInputField<NaturalPersonMutationDto>
                    labelKey="party.edit.identification.identificationnumber"
                    fieldName="identificationNumber"
                />
                <FormikInputField<NaturalPersonMutationDto>
                    labelKey="party.edit.identification.identificationpersonalnumber"
                    fieldName="identificationPersonalNumber"
                />
                <FormikComboboxField<NaturalPersonMutationDto, EnumComboboxProps<IdentificationType>>
                    labelKey="party.edit.identification.identificationtype"
                    fieldName="identificationType"
                    component={EnumCombobox}
                    componentProps={{ entities: Object.values(IdentificationType), labelKeyPrefix: 'party.edit.identification.type' }}
                />
            </FieldRow>
            <FieldRow>
                <FormikField<LocalDatePickerProps, NaturalPersonMutationDto>
                    labelKey="party.edit.identification.identificationdateofissue"
                    fieldName="identificationDateOfIssue"
                    component={LocalDatePicker}
                    componentProps={{ isoValue: values.identificationDateOfIssue, onSelectDate: date => setFieldValue('identificationDateOfIssue', date) }}
                />
                <FormikField<LocalDatePickerProps, NaturalPersonMutationDto>
                    labelKey="party.edit.identification.identificationdateofexpiry"
                    fieldName="identificationDateOfExpiry"
                    component={LocalDatePicker}
                    componentProps={{ isoValue: values.identificationDateOfExpiry, onSelectDate: date => setFieldValue('identificationDateOfExpiry', date) }}
                />
            </FieldRow>
            <FieldRow>
                <FormikInputField<NaturalPersonMutationDto>
                    labelKey="party.edit.identification.identificationauthority"
                    fieldName="identificationAuthority"
                />
                <FormikInputField<NaturalPersonMutationDto>
                    labelKey="party.edit.identification.identificationplaceofissue"
                    fieldName="identificationPlaceOfIssue"
                />
                <FormikComboboxField<NaturalPersonMutationDto, CountryComboboxProps>
                    labelKey="party.edit.identification.identificationcountryofissue"
                    fieldName="identificationCountryOfIssue"
                    component={CountryCombobox}
                />
            </FieldRow>
        </>
    )
}
